export default __webpack_public_path__ + "static/media/dpa.425af6cd.md";